// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.patient.order.ContactLensOrderSearchResponse */
/* istanbul ignore next */
@GandalfModel
export class ContactLensOrderSearchResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	contactLensPrescriptionId!: number | null;

	@GandalfProperty({ designType: Number })
	contactLensTrialId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	expirationDate!: Date | null;

	@GandalfConstantDecorator(constants.ContactLensPrescriptionType)
	@GandalfProperty({ designType: constants.ContactLensPrescriptionType })
	lensType!: constants.ContactLensPrescriptionType | null;

	@GandalfProperty({ designType: String })
	odManufacturer!: string | null;

	@GandalfProperty({ designType: String })
	odModelName!: string | null;

	@GandalfProperty({ designType: String })
	osManufacturer!: string | null;

	@GandalfProperty({ designType: String })
	osModelName!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.PrescriptionCurrentStatus)
	@GandalfProperty({ designType: constants.PrescriptionCurrentStatus })
	status!: constants.PrescriptionCurrentStatus | null;

}
